import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidates|Program History|Credentials|Details|';
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'portal' | 'feature'> = {
	htmlAllowed: false,
	shared: false,
	portal: 'SP',
	feature: HubFeature.Credential,
};

export type CredentialDetailsLoc =
	| 'SPCredentialDetailsLabelVerificationId'
	| 'SPCredentialDetailsLabelStarted'
	| 'SPCredentialDetailsLabelActive'
	| 'SPCredentialDetailsLabelInactive'
	| 'SPCredentialDetailsLabelExpires'
	| 'SPCredentialDetailsLabelRetired'
	| 'SPCredentialDetailsTitleProgress'
	| 'SPCredentialDetailsTitleHistory'
	| 'SPCredentialDetailsButtonHistory'
	| 'SPCredentialDetailsButtonProgress';

export const spCredentialDetailsLocs: LocDefs<CredentialDetailsLoc> = {
	SPCredentialDetailsLabelVerificationId: {
		defaultValue: 'Verification ID',
		displayType: 'Label',
		description: 'Label for the Verification ID field',
		displayPath: `${dpRoot}Verification ID`,
		...sharedProps,
	},
	SPCredentialDetailsLabelStarted: {
		defaultValue: 'Started',
		displayType: 'Label',
		description: 'Label for the Started field',
		displayPath: `${dpRoot}Started`,
		legacyName: 'Credential/Candidates.CredentialsDetails.FieldLabel.Started',
		...sharedProps,
	},
	SPCredentialDetailsLabelActive: {
		defaultValue: 'Active',
		displayType: 'Label',
		description: 'Label for the Active field',
		displayPath: `${dpRoot}Active`,
		legacyName: 'Credential/Candidates.CredentialsDetails.FieldLabel.Active',
		...sharedProps,
	},
	SPCredentialDetailsLabelInactive: {
		defaultValue: 'Inactive',
		displayType: 'Label',
		description: 'Label for the Inactive field',
		displayPath: `${dpRoot}Inactive`,
		legacyName: 'Credential/Candidates.CredentialsDetails.FieldLabel.Inactive',
		...sharedProps,
	},
	SPCredentialDetailsLabelExpires: {
		defaultValue: 'Expires',
		displayType: 'Label',
		description: 'Label for the Expires field',
		displayPath: `${dpRoot}Expires`,
		legacyName: 'Credential/Candidates.CredentialsDetails.FieldLabel.Expires',
		...sharedProps,
	},
	SPCredentialDetailsLabelRetired: {
		defaultValue: 'Retired',
		displayType: 'Label',
		description: 'Label for the Retired field',
		displayPath: `${dpRoot}Retired`,
		...sharedProps,
	},
	SPCredentialDetailsTitleProgress: {
		defaultValue: 'Current Progress',
		displayType: 'Title',
		description: 'Title for the Progress section',
		displayPath: `${dpRoot}Progress Title`,
		legacyName: 'Credential/Candidates.CredentialsDetails.Title.Progress',
		...sharedProps,
	},
	SPCredentialDetailsTitleHistory: {
		defaultValue: 'History',
		displayType: 'Title',
		description: 'Title for the History section',
		displayPath: `${dpRoot}History Title`,
		legacyName: 'Credential/Candidates.CredentialsDetails.Title.History',
		...sharedProps,
	},
	SPCredentialDetailsButtonHistory: {
		defaultValue: 'History',
		displayType: 'Button',
		description: 'Button for the History section',
		displayPath: `${dpRoot}History Button`,
		legacyName: 'Credential/Candidates.CredentialsDetails.Button.History',
		...sharedProps,
	},
	SPCredentialDetailsButtonProgress: {
		defaultValue: 'Progress',
		displayType: 'Button',
		description: 'Button for the Progress section',
		displayPath: `${dpRoot}Progress Button`,
		legacyName: 'Credential/Candidates.CredentialsDetails.Button.Progress',
		...sharedProps,
	},
};

export const LOC_KEYS = MapLocKeys<CredentialDetailsLoc>(spCredentialDetailsLocs);
